<template>
  <div class="system-alerts-content">
    <div class="header-container">
      <span class="title">{{ $t(`${i18nPrefix}.containerTitle.notification`) }}</span>
      <el-button class="more-btn" type="primary" @click="handelToList">{{ $t(`${i18nPrefix}.btn.more`) }}</el-button>
    </div>
    <div class="body-container">
      <div
        class="alerts-items"
        v-for="(item, index) in list"
        :key="index"
      >
        <div :class="item.status === 0 ? 'message-icon read':'message-icon'"></div>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="item.title"
        >
          <div class="alerts-content" @click="handelClickAlerts(item.id)">{{ item.title }}</div>
        </el-tooltip>
      </div>
      <div v-if="!loading && list.length === 0" class="alerts-items">
        <div class="alerts-content">{{ $t(`${i18nPrefix}.message.notification.noMessage`) }}</div>
      </div>
    </div>
    <RectLoading class="loading" v-show="loading"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RectLoading from '@/components/loading/rectLoading.vue'

export default {
  components: {
    RectLoading
  },
  data () {
    return {
      i18nPrefix: 'admin.hrDashboard',
      list: [],
      loading: false,
      pageSetting: {
        page: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  computed: {},
  created () {
    this.initList()
  },
  methods: {
    ...mapActions('notification', ['getNotificationList']),
    async initList () {
      this.loading = true
      try {
        const resp = await this.getNotificationList({ page: this.pageSetting.page, page_size: this.pageSetting.pageSize })
        if (resp) {
          this.pageSetting.total = resp.count
          this.list = resp.results
        }
      } finally {
        this.loading = false
      }
    },
    handelClickAlerts (alertsId) {
      if (!alertsId) {
        return
      }
      window.open(`/v-admin/notification/detail/${alertsId}`)
    },
    handelToList () {
      window.open('/v-admin/notification/list')
    }
  }
}
</script>

<style lang="scss" scoped>
.system-alerts-content {
  background: #FFFFFF;
  border-radius: 6px;
  color: #303133;
  font-weight: 400;
  margin-bottom: 15px;
  position: relative;

  .header-container {
    padding: 20px 24px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 18px;
      height: 25px;
      line-height: 25px;
      font-weight: bold;
    }

    .more-btn {
      padding: 2px 12px;
      height: 26px;
      font-weight: 400;
      background-color: #0096cc;
    }
  }

  .body-container {
    padding: 0 18px 6px;
    min-height: 100px;

    .alerts-items {
      display: flex;
      align-items: center;
      margin-bottom: 9px;

      .message-icon {
        width: 6px;
        height: 6px;
        flex-shrink: 0;
        background: #EE7815;
        border-radius: 50%;
        margin: 2px 8px 0 0;

        &.read {
          background: #DCDFE6;
        }
      }

      .alerts-content {
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        color: #606266;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        cursor: pointer;
      }
    }
  }
}
#main {
  .loading {
    z-index: 1;
    position: absolute;
  }
}
</style>
